import _ from 'lodash';
import { REPORT_TYPE } from '../../pages/frontPage/constants';
import LineChartSimple from './LineChartSimple';
import { CHART_TYPE } from './constants';

// data:
// [
//   {
//     date: 'Page A',
//     value: 4000,
//   }
// ]

const LineChart = ({ chartType, chartData, reportType, currentavgSearches, rowIndex }) => {
  const sortChartData = chartData && Object.entries(chartData).sort(([dateA], [dateB]) => {
    return new Date(dateA) - new Date(dateB);
  })

  const pruchaseUrlData = sortChartData && sortChartData.map(([date, count]) => ({
    date,
    "生成數": count
  }))

  const userQuestionsData = sortChartData && sortChartData.map(([date, count]) => ({
    date,
    "提問數": count
  }))

  // console.log('pruchaseUrlData', pruchaseUrlData);
  // console.log('userQuestionsData', userQuestionsData);

  return (
    <>
      {
        chartType === CHART_TYPE.LINE_CHART_SIMPLE && reportType === REPORT_TYPE.generated_pruchase_urls.id &&
        <LineChartSimple
          chartData={pruchaseUrlData}
          // currentavgSearches={currentavgSearches}
          reportType={REPORT_TYPE.generated_pruchase_urls}
          settings={{
            xkey: 'date',
            ykey: '生成數'
          }}
        />
      }
      {
        chartType === CHART_TYPE.LINE_CHART_SIMPLE && reportType === REPORT_TYPE.user_questions.id &&
        <LineChartSimple
          chartData={userQuestionsData}
          // currentavgSearches={currentavgSearches}
          reportType={REPORT_TYPE.user_questions}
          settings={{
            xkey: 'date',
            ykey: '提問數'
          }}
        />
      }
    </>
  );
};

export default LineChart;